import React from 'react';
import { useGame } from '../context/GameContext';
import GameCard from '../components/GameCard';
import { upgradeBranches } from '../game/cards';
import { ArrowLeft } from 'lucide-react';

// When upgrading a card with branches, prompt the player to choose one.
export default function UpgradePick() {
  const { pendingBranchPick, choosePendingBranch, cancelBranchPick } = useGame();
  if (!pendingBranchPick) return null;
  const branches = upgradeBranches(pendingBranchPick.baseId);
  return (
    <div className="min-h-screen w-full px-6 py-6" data-testid="branch-pick-screen">
      <div className="flex items-center justify-between">
        <button className="brutal-btn text-sm" onClick={cancelBranchPick} data-testid="branch-cancel">
          <ArrowLeft size={16}/> BACK
        </button>
        <h1 className="font-display text-3xl sm:text-4xl font-black uppercase text-[color:var(--neon)]">PICK AN UPGRADE PATH</h1>
        <div className="w-24"/>
      </div>
      <div className="mt-10 flex flex-wrap gap-6 justify-center">
        {branches.map((bid) => (
          <div key={bid} onClick={() => choosePendingBranch(bid)} className="cursor-pointer hover:scale-105 transition-transform">
            <GameCard cardId={bid} testid={`branch-${bid}`} />
          </div>
        ))}
      </div>
    </div>
  );
}
